import navigateToNextAlzheimerPageAction from '@actions/navigateToNextAlzheimerPageAction'
import AlcoholPage from '@pages/baseline/onboarding/AlcoholPage'
import BiologicalSexPage from '@pages/baseline/onboarding/BiologicalSexPage'
import BirthYearPage from '@pages/baseline/onboarding/BirthYearPage'
import BloodGlucosePage from '@pages/baseline/onboarding/BloodGlucosePage'
import BloodPressurePage from '@pages/baseline/onboarding/BloodPressurePage'
import CancerScreeningsPage from '@pages/baseline/onboarding/CancerScreeningsPage'
import ChildrenPage from '@pages/baseline/onboarding/ChildrenPage'
import CholesterolPage from '@pages/baseline/onboarding/CholesterolPage'
import CountryPage from '@pages/baseline/onboarding/CountryPage'
import DoctorCheckupsPage from '@pages/baseline/onboarding/DoctorCheckupsPage'
import ExerciseFrequencyPage from '@pages/baseline/onboarding/ExerciseFrequencyPage'
import FruitsAndVeggiesPage from '@pages/baseline/onboarding/FruitsAndVeggiesPage'
import GrandparentsLifespanPage from '@pages/baseline/onboarding/GrandparentsLifespanPage'
import HeightPage from '@pages/baseline/onboarding/HeightPage'
import IncomeLevelPage from '@pages/baseline/onboarding/IncomeLevelPage'
import JobPage from '@pages/baseline/onboarding/JobPage'
import LivingLocationPage from '@pages/baseline/onboarding/LivingLocationPage'
import ProcessedFoodPage from '@pages/baseline/onboarding/ProcessedFoodPage'
import RelationshipStatusPage from '@pages/baseline/onboarding/RelationshipStatusPage'
import RunningDifficultyPage from '@pages/baseline/onboarding/RunningDifficultyPage'
import SittingTimePage from '@pages/baseline/onboarding/SittingTimePage'
import SleepHoursPage from '@pages/baseline/onboarding/SleepPage'
import SleepTroublePage from '@pages/baseline/onboarding/SleepTroublePage'
import SmokingPage from '@pages/baseline/onboarding/SmokingPage'
import SocialTimePage from '@pages/baseline/onboarding/SocialTimePage'
import StressPage from '@pages/baseline/onboarding/StressPage'
import SugarIntakePage from '@pages/baseline/onboarding/SugarIntakePage'
import SunProtectionPage from '@pages/baseline/onboarding/SunProtectionPage'
import WaterIntakePage from '@pages/baseline/onboarding/WaterIntakePage'
import WeightPage from '@pages/baseline/onboarding/WeightPage'
import AgeRiskFactPage from './AgeRiskFactPage'
import BloodPressureTreatmentPage from './BloodPressureTreatmentPage'
import BrainHealthIntroPage from './BrainHealthIntroPage'
import CognitiveActivityFrequencyPage from './CognitiveActivityFrequencyPage'
import CognitiveFactPage from './CognitiveFactPage'
import CognitiveGoalPage from './CognitiveGoalPage'
import DailyMemoryIssuesPage from './DailyMemoryIssuesPage'
import DementiaExerciseFrequencyPage from './DementiaExerciseFrequencyPage'
import DiabetesDiagnosisPage from './DiabetesDiagnosisPage'
import FamilyDementiaHistoryPage from './FamilyDementiaHistoryPage'
import HabitsBrainIntroPage from './HabitsBrainIntroPage'
import HearingDifficultyPage from './HearingDifficultyPage'
import LifestyleImpactIntroPage from './LifestyleImpactIntroPage'
import LonelinessFrequencyPage from './LonelinessFrequencyPage'
import MemoryConcernFrequencyPage from './MemoryConcernFrequencyPage'
import NightWakeUpsPage from './NightWakeUpsPage'
import PreventionIntroPage from './PreventionIntroPage'
import SleepFactPage from './SleepFactPage'

const alzheimerRoutes = [
  {
    action: navigateToNextAlzheimerPageAction,
    element: <BiologicalSexPage />,
    path: 'start',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <BrainHealthIntroPage />,
    path: 'brain-health-intro',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <MemoryConcernFrequencyPage />,
    path: 'memory-concern-frequency',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <FamilyDementiaHistoryPage />,
    path: 'family-dementia-history',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <DementiaExerciseFrequencyPage />,
    path: 'dementia-exercise-frequency',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <CognitiveGoalPage />,
    path: 'cognitive-goal',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <DailyMemoryIssuesPage />,
    path: 'daily-memory-issues',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <CognitiveActivityFrequencyPage />,
    path: 'cognitive-activity-frequency',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <CognitiveFactPage />,
    path: 'cognitive-fact',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <HearingDifficultyPage />,
    path: 'hearing-difficulty',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <LonelinessFrequencyPage />,
    path: 'loneliness-frequency',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <NightWakeUpsPage />,
    path: 'night-wake-ups',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <DiabetesDiagnosisPage />,
    path: 'diabetes-diagnosis',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <BloodPressureTreatmentPage />,
    path: 'blood-pressure-treatment',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <LifestyleImpactIntroPage />,
    path: 'lifestyle-impact-intro',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <BirthYearPage />,
    path: 'birth-year',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <AgeRiskFactPage />,
    path: 'age-risk-fact',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <CountryPage />,
    path: 'country',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <HeightPage />,
    path: 'height',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <WeightPage />,
    path: 'weight',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <ExerciseFrequencyPage />,
    path: 'exercise-frequency',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <RunningDifficultyPage />,
    path: 'running-difficulty',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <SittingTimePage />,
    path: 'sitting-time',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <IncomeLevelPage />,
    path: 'income-level',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <JobPage />,
    path: 'job',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <LivingLocationPage />,
    path: 'living-location',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <RelationshipStatusPage />,
    path: 'relationship-status',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <SocialTimePage />,
    path: 'social-time',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <ChildrenPage />,
    path: 'children',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <HabitsBrainIntroPage />,
    path: 'habits-brain-intro',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <SmokingPage />,
    path: 'smoking',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <AlcoholPage />,
    path: 'alcohol',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <SleepHoursPage />,
    path: 'sleep',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <StressPage />,
    path: 'stress',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <SleepTroublePage />,
    path: 'sleep-trouble',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <SleepFactPage />,
    path: 'sleep-fact',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <PreventionIntroPage />,
    path: 'prevention-intro',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <GrandparentsLifespanPage />,
    path: 'grandparents-lifespan',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <DoctorCheckupsPage />,
    path: 'doctor-checkups',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <CancerScreeningsPage />,
    path: 'cancer-screenings',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <BloodPressurePage />,
    path: 'blood-pressure',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <CholesterolPage />,
    path: 'cholesterol',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <BloodGlucosePage />,
    path: 'blood-glucose',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <SunProtectionPage />,
    path: 'sun-protection',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <WaterIntakePage />,
    path: 'water-intake',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <SugarIntakePage />,
    path: 'sugar-intake',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <ProcessedFoodPage />,
    path: 'processed-food',
  },
  {
    action: navigateToNextAlzheimerPageAction,
    element: <FruitsAndVeggiesPage />,
    path: 'fruits-and-veggies',
  },
]

export default alzheimerRoutes
